var _g, _g2, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 189,
    viewBox: "0 0 1440 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M998.714 45.4472C1007.14 38.3403 1010.28 20.7051 1007.79 7.43559C996.026 -63.227 939.207 68.7475 998.714 45.4472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.369 -107.766C849.303 -124.264 882.408 0.47113 904.296 -62.6378C911.974 -82.5777 914.702 -103.309 897.369 -107.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.443 176.894C679.069 171.33 685.073 116.851 715.369 126.263C729.792 137.542 725.633 186.864 696.443 176.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.741 17.0606C811.328 85.2661 741.171 25.2335 822.586 9.6695C827.871 10.0655 848.978 4.27843 852.741 17.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.22 68.128C1152.58 91.073 983.186 134.486 1046.83 73.8034C1047.9 72.626 1049.17 71.6346 1050.56 70.8692C1057.35 67.6711 1064.58 65.1634 1074.22 68.128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.075 84.9717C979.523 75.9764 935.291 57.3361 915.087 87.7941C916.385 111.521 986.623 121.298 976.075 84.9717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.833 1.92275C678.703 -12.159 626.752 53.9145 685.306 48.625C693.948 43.3659 717.691 13.8318 707.833 1.92275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.8 -89.492C1112.87 -85.9284 1109.17 1.39465 1154.83 -26.7485C1167.25 -37.622 1151.13 -90.9641 1130.8 -89.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 -48.3127C1083.74 -31.1649 1067.35 49.3863 1031.77 6.97862C1022.87 -6.20968 1011.75 -37.7438 1024.48 -48.3127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.1 28.5734C940.667 -61.9376 832.75 50.1478 902.795 51.356C910.899 49.6909 914.033 37.6601 918.1 28.5734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.557 83.2249C728.169 135.43 757.836 79.6309 733.727 51.7517C731.617 45.7109 692.092 46.7261 709.557 83.2249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.37 33.6193C1145.33 37.2641 1202.81 -10.291 1165.65 -16.1288C1137.65 -20.5757 1076.98 31.67 1132.37 33.6193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.81 -40.6371C780.15 -47.3683 821.624 33.5281 764.794 9.9942C749.469 1.49643 723.362 -25.7736 731.81 -40.6371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.51 151.695C1016.45 168.894 1040.67 246.399 1072.92 204.59C1084.48 190.813 1094.4 160.477 1083.51 151.695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.54 218.164C1252.62 167.665 1137.67 226.144 1203.94 234.408C1224.98 237.738 1245.81 236.083 1246.54 218.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.447 90.3323C870.755 102.82 842.01 149.461 818.672 127.968C810.477 111.561 835.336 68.8086 857.447 90.3323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.3 142.669C1155.6 147.542 1181.16 106.901 1154.46 81.9765C1130.87 79.3977 1109.78 147.197 1147.3 142.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.6 157.674C1054.85 120.698 992.03 114.302 975.335 147.187C970.568 151.41 986.441 187.665 1013.6 157.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.387 178.63C770.87 193.047 721.14 107.338 780.515 125.714C794.624 130.08 812.881 159.066 803.387 178.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.206 141.39C889.102 116.252 884.031 220.103 905.949 209.412C921.792 206.58 947.331 150.791 919.206 141.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.81 -58.1709C1362.04 -68.1002 1345.74 -75.5319 1332.33 -76.4456C1260.98 -82.588 1374.55 5.32384 1366.81 -58.1709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.74 4.19695C1174.69 21.3955 1198.92 98.8908 1231.15 57.0923C1242.71 43.3151 1252.64 12.979 1241.74 4.19695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404.24 81.8241C1356.18 65.3159 1389.28 190.062 1411.16 126.942C1418.86 107.003 1421.6 86.2709 1404.24 81.8241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.05 63.3159C1307.27 66.0774 1322.47 20.5224 1290.62 2.66386C1267.09 5.76043 1262.68 76.626 1298.05 63.3159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.39 117.541C1332.46 121.115 1328.76 208.438 1374.42 180.294C1386.84 169.421 1370.72 116.079 1350.39 117.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.55 -9.27555C1346.16 5.03969 1399.69 74.0981 1416.38 23.081C1418.85 6.74535 1372.12 -23.54 1357.55 -9.27555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.43 103.713C1268.68 120.861 1252.29 201.412 1216.71 159.005C1207.81 145.816 1196.69 114.282 1209.43 103.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.84 230.601C1308.55 243.962 1374.79 278.318 1365.66 241.769C1358.75 214.286 1287 178.802 1306.84 230.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.45 76.0472C1231.88 96.3525 1294.58 137.247 1306.19 112.16C1305.65 97.1343 1275.97 57.478 1253.45 76.0472Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.04,
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.557 186.894C143.931 181.33 137.927 126.851 107.631 136.263C93.208 147.542 97.3665 196.864 126.557 186.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.7406 27.0606C11.6719 95.2661 81.8286 35.2335 0.413502 19.6695C-4.87082 20.0655 -25.9777 14.2784 -29.7406 27.0606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.167 11.9228C144.297 -2.15898 196.248 63.9145 137.694 58.625C129.053 53.3659 105.309 23.8318 115.167 11.9228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.443 93.2249C94.831 145.43 65.1638 89.6309 89.2729 61.7517C91.3825 55.7109 130.908 56.7261 113.443 93.2249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1895 -30.6371C42.8496 -37.3683 1.37634 43.5281 58.2056 19.9942C73.5312 11.4964 99.6383 -15.7736 91.1895 -30.6371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.4474 100.332C-47.7546 112.82 -19.0103 159.461 4.32796 137.968C12.5232 121.561 -12.3364 78.8086 -34.4474 100.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.613 188.63C52.1303 203.047 101.86 117.338 42.4847 135.714C28.3763 140.08 10.1195 169.066 19.613 188.63Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 988,
    height: 179,
    fill: "white",
    transform: "translate(452)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 988,
    height: 179,
    fill: "white",
    transform: "matrix(-1 0 0 1 371 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroMessage);
export default __webpack_public_path__ + "static/media/heroMessage.124ba97f1af99a3bba1827ad4a8d29e7.svg";
export { ForwardRef as ReactComponent };